import { string } from "prop-types";
import { StringParam } from "use-query-params";

const propTypes = {
  type: string.isRequired,
  title: string.isRequired,
  linkUrl: string.isRequired,
  description: string.isRequired,
  date: string.isRequired,
  time: string,
  timezone: string,
  locationOne: string.isRequired,
  registrationLinkLabel: string,
  registrationLinkUrl: string,
};

const ManualEventItem = (props) => {
  const {
    type,
    title,
    linkUrl,
    description,
    date,
    time,
    timezone,
    locationOne,
    registrationLinkLabel,
    registrationLinkUrl,
  } = props;

  return (
    <div className="manual-event-item__wrapper">
      <div className="manual-event-item__event-type">
        <p>{type}</p>
      </div>
      <div className="manual-event-item__event-container">
        <div className="manual-event-item__left-content">
          {linkUrl ? (
            <h2 className="manual-event-item__event-title">
              <a href={linkUrl}>{title}</a>
            </h2>
          ) : (
            <h2 className="manual-event-item__event-title">{title}</h2>
          )}

          <p className="manual-event-item__event-description">{description}</p>
        </div>

        <div className="manual-event-item__right-content">
          <div className="manual-event-item__date-time-location-container">
            <div className="manual-event-item__date-container">
              <h3 className="manual-event-item__date">{date}</h3>
            </div>

            <div className="manual-event-item__time-container">
              {time ? (
                <>
                  <p className="manual-event-item__time">{time}</p>
                  <p className="manual-event-item__timezone"> {timezone}</p>
                </>
              ) : null}
            </div>

            <div className="manual-event-item__location-container">
              <p
                className="manual-event-item__location-one"
                dangerouslySetInnerHTML={{ __html: locationOne }}
              ></p>
              {/* {locationTwo ? (
                <>
                  <span> / </span>
                  <a
                    href={locationTwoUrl}
                    className="manual-event-item__location-two"
                  >
                    {locationTwo}
                  </a>
                </>
              ) : null} */}
            </div>
          </div>
          {registrationLinkLabel ? (
            <div className="manual-event-item__event-link-container">
              <a
                href={registrationLinkUrl}
                className="manual-event-item__event-link"
              >
                {registrationLinkLabel}
              </a>
            </div>
          ) : null}
        </div>
      </div>
    </div>
  );
};

ManualEventItem.propTypes = propTypes;
export default ManualEventItem;
